import { Palette, TypographyVariantsOptions } from '@mui/material/styles';
// import { CSSProperties } from 'react'

// declare module '@mui/material/styles' {
//   interface TypographyVariants {
//     chip: CSSProperties
//   }
//   interface TypographyVariantsOptions {
//     chip?: CSSProperties
//   }
// }

// declare module '@mui/material/Typography' {
//   interface TypographyPropsVariantOverrides {
//     chip: true
//   }
// }

const getTypographyMixin = (palette: Palette): TypographyVariantsOptions => ({
  fontFamily: [
    'Roboto',
    '"Noto Sans TC"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),

  h4: {
    fontSize: '2rem',
  },

  // In Chinese and Japanese the characters are usually larger,
  // so a smaller fontsize may be appropriate.
  // fontSize: 12,
});

export default getTypographyMixin;
